import { Fragment, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import IsAuth from '../../utillityComponents/IsAuth'
import moment from 'moment'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function AllEventList(props) {

  const [showAll, setShowAll] = useState(false)
  const [openCreateMenu, setOpenCreateMenu] = useState(false)

  const now = useMemo(() => moment(), [])
  const currentYear = now.year()

  const filterByYear = (dateStr) => {
    if (showAll) return true
    if (!dateStr) return false
    return moment(dateStr).year() === currentYear
  }

  const filteredEvents = useMemo(() => {
    if (!props.events) return []
    const groups = props.events.map((group) => {
      const kept = (group.events || []).filter((ev) => filterByYear(ev.event_start_date))
      return { ...group, events: kept }
    }).filter((g) => g.events && g.events.length > 0)
    return groups.sort((a, b) => (a.name > b.name ? 1 : -1))
  }, [props.events, showAll, currentYear])

  const upcomingFlat = useMemo(() => {
    if (!props.events) return []
    const flat = []
    props.events.forEach((group) => {
      (group.events || []).forEach((ev) => {
        if (moment(ev.event_start_date).isAfter(now)) {
          flat.push(ev)
        }
      })
    })
    // Sort by soonest start
    flat.sort((a, b) => moment(a.event_start_date).valueOf() - moment(b.event_start_date).valueOf())
    return flat
  }, [props.events, now])

  return (
      <>
    <h2 className="max-w-6xl mx-auto mt-8 px-4 text-lg leading-6 font-medium text-gray-900 sm:px-6 lg:px-8">
    {props.title}
  </h2>
    <div className="px-4 sm:px-6 lg:px-8">
      {/* Top controls: Create dropdown + filter toggle */}
      <div className="mt-4 flex items-center justify-between">
        {IsAuth(['Admin', 'Ngo']) ? (
          <div className="relative inline-block text-left">
            <button
              type="button"
              onClick={() => setOpenCreateMenu((v) => !v)}
              className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 focus:outline-none"
            >
              Opret
              <svg className="-mr-1 h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.08 1.04l-4.25 4.25a.75.75 0 01-1.06 0L5.25 8.27a.75.75 0 01-.02-1.06z" clipRule="evenodd" />
              </svg>
            </button>
            {openCreateMenu ? (
              <div className="absolute left-0 z-10 mt-2 w-44 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="py-1">
                  <button
                    type="button"
                    className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50"
                    onClick={() => { setOpenCreateMenu(false); props.openPopup && props.openPopup(); }}
                  >
                    Event
                  </button>
                  <button
                    type="button"
                    className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50"
                    onClick={() => { setOpenCreateMenu(false); props.openPopupOrg && props.openPopupOrg(); }}
                  >
                    Organisation
                  </button>
                </div>
              </div>
            ) : null}
          </div>
        ) : <div />}

        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-600 hidden sm:inline">Vis</span>
          <button
            type="button"
            onClick={() => setShowAll(false)}
            className={classNames(!showAll ? 'bg-indigo-100 text-indigo-700' : 'text-gray-600 hover:text-gray-800', 'rounded-md px-3 py-1.5 text-sm font-medium')}
          >
            I år ({currentYear})
          </button>
          <button
            type="button"
            onClick={() => setShowAll(true)}
            className={classNames(showAll ? 'bg-indigo-100 text-indigo-700' : 'text-gray-600 hover:text-gray-800', 'rounded-md px-3 py-1.5 text-sm font-medium')}
          >
            Alle events
          </button>
        </div>
      </div>

      {/* Upcoming events section */}
      <div className="mt-6">
        <h3 className="text-md font-medium text-gray-900">Aktuelle events</h3>
        {upcomingFlat.length === 0 ? (
          <p className="mt-2 text-sm text-gray-500">Ingen kommende events.</p>
        ) : (
          <ul className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {upcomingFlat.slice(0, 9).map((ev) => (
              <li key={ev.id} className="rounded-md border border-gray-200 bg-white p-3 shadow-sm">
                <div className="flex items-center">
                  <img className="h-8 w-8 rounded mr-3" src={ev.img + '/36x36'} alt={ev.name} />
                  <div className="min-w-0 flex-1">
                    <Link to={"/events/"+ev.slug} className="truncate text-sm font-medium text-indigo-700 hover:text-indigo-900">
                      {ev.name}
                    </Link>
                    <p className="text-xs text-gray-500">Start: {moment(ev.event_start_date).format('ddd, DD MMM HH:mm YYYY')}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="mt-8 flex flex-col">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table className="min-w-full">
                <thead className="bg-white">
                  <tr>
                    <th>

                    </th>
                    <th scope="col" className="py-3.5 pl-0 pr-3 text-center text-sm font-semibold text-gray-900 sm:pl-0">
                      Navn
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">
                      Start tidspunkt
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">
                      Slut tidspunkt
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">
                      Slug
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">
                      Rediger
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {(filteredEvents.length > 0 ? filteredEvents : props.events).sort((a, b) => a.name > b.name ? 1 : -1).map((event) => (
                    <Fragment key={event.name}>
                      <tr className="border-t border-gray-200">
                        <th
                          colSpan={6}
                          scope="colgroup"
                          className="bg-gray-50 px-4 py-2 text-left text-sm font-semibold text-gray-900 sm:px-6"
                        >
                          {event.name}

                         {/*  <Link to="/" className="text-indigo-600 hover:text-indigo-900 float-right">
                              Edit<span className="sr-only">, {event.name}</span>
                            </Link> */}
                        </th>
                      </tr>
                      {event.events.map((events, eventsIdx) => (
                        <tr
                          key={events.id}
                          className={classNames(eventsIdx === 0 ? 'border-gray-300' : 'border-gray-200', 'border-t')}
                        >
                          <td
                           className='py-2 block h-9 w-9 rounded-full ml-4 mr-3'
                          >
                          <img
                            className="block h-9 w-9 rounded-full ml-4"
                            src={events.img + "/36x36"}
                            alt={events.name}
                          />
                          </td>
                          <td className="whitespacepy-4 pl-0 pr-3 text-sm font-medium text-gray-900 sm:pl-3">
                          <Link to={"/events/"+events.slug} className="text-indigo-600 hover:text-indigo-900">
                            {events.name}
                          </Link>
                            <br></br>
                            <span className={events.event_group != null ? 'inline-flex rounded-full bg-blue-100 px-2 text-xs font-semibold leading-5 text-blue-800' : ''}>
                              {events.event_group != null ? 'Eventgruppe: ' + events.event_group : ''}
                            </span>
                            {events.app_codes && (
                              <>
                                <br></br>
                                <span className="text-xs text-gray-500">
                                  App Code: {events.app_codes.join(', ')}
                                </span>
                              </>
                            )}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{moment(events.event_start_date).format("dddd, DD MMM HH:mm YYYY")}</td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{moment(events.event_end_date).format("dddd, DD MMM HH:mm YYYY")}</td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{events.slug}</td>
                          <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                          {IsAuth(['Admin', 'Ngo', 'Org_admin']) ?
                            <>
                            <Link
                            key={event.name + "_edit"}
                              className="text-indigo-600 hover:text-indigo-900"
                              to={`/events/edit/${events.slug}`}
                            >
                              Rediger
                            </Link>
                            </>
                            : ""}
                            {IsAuth(['Admin', 'Ngo']) ?
                            <>
                            <br></br>
                            <br></br>
                            <button
                            key={event.name + "_edit_route"}
                              type="button"
                              className= "text-indigo-600 hover:text-indigo-900"
                              onClick= {() => props.openPopupUpdateRoute(events.slug)}
                            >
                              Ruter
                            </button>
                            </>
                            : ""}
                          </td>
                        </tr>
                      ))}
                    </Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <br></br>
      {/* Replaced with unified dropdown above */}
    </div>
    </>
  )
}